import { DrawerClose } from '@/components/ui/drawer';
import { Drawer } from '@/pages/offboarding/med-g/Drawer';
import { LuX } from 'react-icons/lu';

interface SurveyDrawerProps {
  showSurvey: boolean;
  setShowSurvey: (show: boolean) => void;
  maxScore: number;
  handleRatingPress: (rating: number) => void;
}

export const SurveyDrawer = ({
  showSurvey,
  setShowSurvey,
  maxScore,
  handleRatingPress,
}: SurveyDrawerProps) => {
  return (
    <Drawer open={showSurvey} onClose={() => setShowSurvey(false)}>
      <div className="w-full h-full px-4 sm:px-8 py-4 sm:py-8 rounded-t-xl flex justify-center items-center">
        <div className="flex flex-col items-center bg-white border border-gray-200 shadow-md rounded-3xl px-2 pt-2 pb-6  w-96 sm:w-full">
          <DrawerClose className="flex justify-end cursor-pointer hover:text-gray-500 w-full pr-1">
            <LuX size={22} strokeWidth={1.5} />
          </DrawerClose>
          <div className="flex flex-col items-center gap-5">
            <p className="text-base font-medium">
              Comment avez-vous trouvé
              <br />
              votre expérience au global ?
            </p>

            <div className="flex flex-col w-full gap-4">
              <div className="flex justify-between items-center w-full px-12 sm:px-6 text-base font-medium gap-1">
                {[...Array(maxScore)].map((_, index) => (
                  <button
                    key={index + 1}
                    className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center hover:bg-blue-100 hover:cursor-pointer"
                    onClick={() => handleRatingPress(index + 1)}
                    type="button"
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
              <div className="flex justify-between text-sm text-gray-400 px-12 sm:px-6 text-xs">
                <span>Très mauvaise</span>
                <span>Très bonne</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
